export const MELTS = 'melts';
export const MELTS_RECIPE_PAGE_VIEW = 'MeltsRecipePageView';
export const PIZZA_RECIPE_PAGE_VIEW = 'PizzaRecipePageView';
export const MULTI_CLASS_PAGE_VIEW = 'MultiClassRecipePageView';
export const TAVERN_RECIPES_TITLE = 'Tavern Style Recipes';
export const SIGNATURE_RECIPES_TITLE = 'Signature Recipes';
